import React from "react";
import { useContext } from "react";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../../Localization/LanguageContext";
import { Paragraph } from "@saif/paragraph";
import { AutoLink } from "@saif/link";
import { LandingPage } from "../../../Components/LandingPage/LandingPage";
import "./styles.css";

const Forwarded = () => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;

  return (
    <LandingPage
      iconProps={{
        icon: "paper-plane",
        size: "xxl",
      }}
      headingProps={{
        size: "xl",
        isLoading: false,
        center: true,
        children: getValue("Forwarded", "Title"),
      }}
      description={
        <>
          <Paragraph>
            {getValue("Forwarded", "TitleSub")}
            &nbsp;
            {getValue("Forwarded", "TitleSub2Prefix")}
            <AutoLink
              type="phone"
              value={getValue("Forwarded", "Phone")}
            />
            {getValue("Forwarded", "TitleSub2Suffix")}
          </Paragraph>
        </>
      }
    />
  );
};

export default Forwarded;
